import types from "cms/enums/contentsTypes.enum";
export var expansionPanelDetails = {
    label: "Expansion Panel",
    type: types.EXPANSION_PANEL_DETAILS,
    dynamicChildKey: "detailsElements"
};
